import { useEffect, useState } from "react";
import { useProfile } from "@/context/ProfileContext";
import DiscountBanner from "@/components/DiscountBanner";
import Navbar from "@/components/Navbar";
import Onboarding from "@/components/Onboarding";
import Hero from "@/components/Hero";
import WeatherCorredino from "@/components/WeatherCorredino";
import Catalog from "@/components/Catalog";
import GrowthChart from "@/components/GrowthChart";
import FabricGuide from "@/components/FabricGuide";
import HospitalBag from "@/components/HospitalBag";
import MyList from "@/components/MyList";
import MyProfile from "@/components/MyProfile";
import BornDashboard from "@/components/BornDashboard";
import PrepTimeline from "@/components/PrepTimeline";
import { CoordinatedLook } from "@/components/CoordinatedLook";
import { Link } from "react-router-dom";
import { MobileNav } from "@/components/MobileNav";
import School from "@/components/School";
import MostLoved from "@/components/MostLoved";
import BirthSets from "@/components/BirthSets";
import { ListHowTo } from "@/components/ListHowTo";
import { BabyNameCard } from "@/components/BabyNameCard";
import { FactPills } from "@/components/FactPills";
import WelcomeTour from "@/components/WelcomeTour";
import { CuratedSets } from "@/components/CuratedSets";
import NewArrivals from "@/components/NewArrivals";

const HomePills = () => (
  <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 pb-6 sm:pb-10"><FactPills /></div>
);

export default function Home() {
  const { profile, loading } = useProfile();
  const [listOpen, setListOpen] = useState(false);
  const [profileOpen, setProfileOpen] = useState(false);
  useEffect(() => {
    if (profile && new URLSearchParams(window.location.search).has("misure")) setProfileOpen(true);
  }, [profile]);
  const [sharedView, setSharedView] = useState(() => window.location.hash === "#piu-amati");
  const [tourDone, setTourDone] = useState(() => localStorage.getItem("mb_onb_mode") === "login");
  useEffect(() => {
    if (!profile && localStorage.getItem("mb_onb_mode") === "login") setTourDone(true);
  }, [profile]);
  const endTour = (login) => { if (login) localStorage.setItem("mb_onb_mode", "login"); setTourDone(true); };

  const dd = profile?.due_date;
  const isBorn = dd ? new Date(dd.year, dd.month - 1, dd.day) <= new Date() : false;

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FAF8F5]">
        <div className="font-serif text-2xl text-[#C87D75] animate-pulse">Minime Baby</div>
      </div>
    );
  }

  return (
    <div className={`min-h-screen bg-[#FAF8F5] ${profile ? "pb-[64px] lg:pb-0" : ""}`}>
      <DiscountBanner />
      <Navbar onOpenList={() => setListOpen(true)} onOpenProfile={() => setProfileOpen(true)} />
      {!profile && !sharedView && !tourDone && <WelcomeTour onRegister={() => endTour(false)} onLogin={() => endTour(true)} />}
      <Onboarding open={!profile && !sharedView && tourDone} />

      <main>
        {isBorn ? (
          <>
            <BabyNameCard />
            <WeatherCorredino />
            <School />
            <BirthSets />
            <BornDashboard onOpenProfile={() => setProfileOpen(true)} />
            <MostLoved />
            <NewArrivals />
            <ListHowTo onOpenList={() => setListOpen(true)} />
            <HomePills />
            <CuratedSets kind="look" />
            <CoordinatedLook />
            <Catalog />
            <GrowthChart />
            <FabricGuide />
          </>
        ) : (
          <>
            <Hero onOpenList={() => setListOpen(true)} />
            <BabyNameCard />
            <WeatherCorredino />
            <School />
            <BirthSets />
            <HospitalBag />
            <CuratedSets kind="bag" />
            <MostLoved onJoin={() => setSharedView(false)} />
            <NewArrivals />
            <ListHowTo onOpenList={() => setListOpen(true)} />
            <HomePills />
            <CuratedSets kind="look" />
            <CoordinatedLook />
            <PrepTimeline />
            <Catalog />
            <GrowthChart />
            <FabricGuide />
          </>
        )}
      </main>

      <footer className="bg-[#282320] text-[#C8BDB3] pt-12 pb-40 lg:pb-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <div className="font-serif text-2xl text-white">Minime Baby</div>
            <p className="text-sm mt-2 max-w-xs">Abbigliamento neonato 100% cotone. Delicato, naturale, elegante.</p>
          </div>
          <div className="text-sm space-y-1">
            <div className="text-white font-display mb-2">Esplora</div>
            <a href="#corredino" className="block hover:text-white">Corredino AI</a>
            <a href="#catalogo" className="block hover:text-white">Catalogo</a>
            <a href="#crescita" className="block hover:text-white">Crescita OMS</a>
            <a href="#tessuti" className="block hover:text-white">Guida ai tessuti</a>
          </div>
          <div className="text-sm space-y-1">
            <div className="text-white font-display mb-2">Shop</div>
            <a href="https://www.minimebaby.it" target="_blank" rel="noreferrer" className="block hover:text-white">minimebaby.it</a>
            <Link to="/admin" data-testid="admin-dashboard-link" className="inline-flex items-center gap-1.5 mt-3 rounded-full border border-white/20 px-3 py-1.5 hover:text-white hover:border-white/50 transition-colors">Dashboard shop (area riservata)</Link>
          </div>
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 mt-8 pt-6 pr-20 lg:pr-12 border-t border-white/10 text-xs">
          © {new Date().getFullYear()} Minime Baby
        </div>
      </footer>

      <MobileNav isBorn={isBorn} onOpenList={() => setListOpen(true)} onOpenProfile={() => setProfileOpen(true)} />
      <MyList open={listOpen} onOpenChange={setListOpen} />
      <MyProfile open={profileOpen} onOpenChange={setProfileOpen} />
    </div>
  );
}
